export default __webpack_public_path__ + "static/media/bitcoin.8d9ecbbd.png";